import React, { useState } from "react";
import { userService } from "../../_services";
import { ConfirmDialog } from "../ui/confirm-dialog";

/**
 * Price/Affiliate Request Confirmation Modal
 * Modernized with shadcn Dialog component
 */
function Price_request_pop({ CloseRequestPopUp, submit_Request_affiliate, submit_Request, request_type }) {
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);

        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const [userId, userName] = Usermeta_Data.split(':');

            if (request_type === "affiliate" || request_type === "ref") {
                await userService.submit_referral_link_request(userId, userName);
                submit_Request_affiliate();
            } else if (request_type === "Admin_request") {
                await userService.Referral_Reject(userId, userName);
                submit_Request_affiliate();
            } else {
                submit_Request();
            }
        } catch (error) {
            console.error('Error submitting request:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        CloseRequestPopUp();
    };

    const getDescription = () => {
        if (request_type === "affiliate" || request_type === "ref") {
            return "Send request to administrator to enable setup Affiliate Referral URL?";
        } else {
            return "Send request to administrator to enable setup for pricing tool?";
        }
    };

    return (
        <ConfirmDialog
            open={true}
            onOpenChange={handleClose}
            title="Request"
            description={getDescription()}
            onConfirm={handleSubmit}
            onCancel={handleClose}
            confirmText="Yes"
            cancelText="No"
            variant="default"
            loading={loading}
            showIcon={false}
        />
    );
}

export default Price_request_pop;
